import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { JwtAuthService } from '../services/auth/jwt-auth.service';

@Injectable({
  providedIn: 'root'
})
export class AdministrationAccessGuard implements CanActivate, CanActivateChild {
  constructor(
    private jwtAuth: JwtAuthService,
    private router: Router
  ) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    return this.canAccess(state.url);
  }

  canActivateChild(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    return this.canAccess(state.url);
  }

  private canAccess(url: string): boolean | UrlTree {
    const storedUser = this.jwtAuth.getUser();
    const userType = String(
      typeof storedUser === 'string'
        ? storedUser
        : storedUser?.user_type ?? this.jwtAuth.checkUserType()
    ).toLowerCase();

    if (userType === 'supplier') {
      return this.router.createUrlTree(['/sales/bookings']);
    }

    if (userType === 'merchant') {
      const path = url.split(/[?#]/)[0].replace(/\/+$/, '');
      const isMerchantSection =
        path === '/administration/merchants' ||
        path.startsWith('/administration/merchants/');

      return isMerchantSection
        ? true
        : this.router.createUrlTree(['/sales/bookings']);
    }

    return true;
  }
}
